import './AwardsModalEndClient.scss'
import React, { useState } from 'react'
import ModalContainer from '../../../../../../../../components/modal-container/ModalContainer'
import { useSendMailFromCRPMutation } from '../../../../../../../../services/crp/sendMail'
import { toast } from 'react-hot-toast'
import { Button } from 'primereact/button'
import { useAwardEndClientProjectMutation } from '../../../../../../../../services/rfq-end-client/rfqEndClient'
import { ROUTES } from '../../../../../../../../config/routes'

function AwardsModalEndClient({ visible, onHide, email, reqCode, isOnboardingComplete = false }) {

  const [sendMail] = useSendMailFromCRPMutation()
  const [awardProject] = useAwardEndClientProjectMutation()
  const [sendingMail, setSendingMail] = useState(false)
  const handleSendMail = async () => {
    const res = awardProject(reqCode).unwrap()
    if (res.error) {
      return toast.error("Unable to Award Project!")
    }
    else {

      setSendingMail(true)
      await sendMail({
        to: email,
        subject: `The project : - ${reqCode} has been awarded to us.  `, // : - project Name (replace with respective value)
        text: `The client has awarded the project with the request code:-  ${reqCode} to us. ${window.location.href} `
      })

      toast.success("Your respective SalesPOC has been notified successfully!")
      setSendingMail(false)
      onHide()
      if (!isOnboardingComplete) {

        toast.error("You have awarded a project, but your onboarding is still pending! Kindly complete your onboarding. Redirecting...", { icon: 'ℹ' })

        setTimeout(() => {
          window.open(ROUTES.HOME, "_blank")
        }, 3000);
      }
    }

  }

  return (
    <ModalContainer header="Award Project" className='AwardsModalEndClient' visible={visible} onHide={onHide} draggable={false} breakpoints={{ '640px': '100vw' }} style={{ width: '50vw' }}>
      <h3 className='py-3 mb-5 text-center'>Do you want to award this project to us?</h3>
      <div className="flex justify-content-center">
        <Button label='No' className="NoButton p-button-rounded   px-5 py-2  mx-3" onClick={onHide} />
        <Button label='Yes' loading={sendingMail} className="YesButton p-button-rounded  mx-3  px-5 py-2" onClick={handleSendMail} />
      </div>
    </ModalContainer>
  )
}

export default AwardsModalEndClient